<template>
    <div class="main">
        <!-- 订餐记录 -->
        <el-dialog
            :modal-append-to-body="false"
            :title="$parent.childrenTitle"
            :visible.sync="openData.state"
            width="990px"
            :before-close="handleClose"
        >
            <!-- :data="tableDate10" -->
            <el-table
                ref="print"
                :data="tableData"
                tooltip-effect="dark"
                highlight-current-row
                :header-cell-style="{ background: '#e6e6e6', color: '#000' }"
                border
            >
                <el-table-column
                    type="index"
                    width="70"
                    prop="order"
                    label="序号"
                    align="center"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    prop="menuDate"
                    label="时间"
                    align="center"
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                    prop="meal"
                    label="订餐类型"
                    align="center"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.meal == 1">早餐</span>
                        <span v-if="scope.row.meal == 2">中餐</span>
                        <span v-if="scope.row.meal == 3">晚餐</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="takeWay"
                    label="取餐方式"
                    align="center"
                    v-if="false"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.takeWay == 0">送餐</span>
                        <span v-if="scope.row.takeWay == 1">堂食</span>
                        <span v-if="scope.row.takeWay == 2">自取</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="foodPrice"
                    label="订餐金额"
                    align="center"
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                    prop="orderType"
                    v-if="false"
                    label="定餐情况"
                    align="center"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.orderType == 1">早餐</span>
                        <span v-if="scope.row.orderType == 2">午餐</span>
                        <span v-if="scope.row.orderType == 3">晚餐</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="istake"
                    label="是否就餐"
                    v-if="false"
                    align="center"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.istake == 0">未完成</span>
                        <span v-if="scope.row.istake == 1">用餐完成</span>
                    </template>
                </el-table-column>

                <el-table-column
                    label="总金额"
                    prop="allfoodPrice"
                    align="center"
                ></el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            ></el-pagination>
            <div slot="footer">
                <el-button type="primary" @click="stamp">打印</el-button>
                <el-button @click="handleClose">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: ["openData", "formData"],
    data() {
        return {
            tableData: [],
            total: 0,
            pageSize: 10,
            pageNo: 1,
        }
    },
    created() {
        this.getList()
    },
    methods: {
        // 获取列表
        getList() {
            let {
                orderType: meals,
                orderEndTime,
                orderStartTime,
                orderTimeOnec,
            } = this.formData

            let params = {
                // customerId: this.openData.customerId,
                pageSize: this.pageSize,
                pageNo: this.pageNo,
                // orderId: this.openData.id,
                communityId: this.openData.socialOrgId,
                meals: meals == true ? [1, 2, 3] : meals,
                orderEndTime,
                orderStartTime,
                orderTimeOnec,

                //  isEnable:
            }

            if (orderEndTime && orderStartTime) {
                delete params.orderTimeOnec
            } else {
                delete params.orderStartTime
                delete params.orderEndTime
            }

            this.$http
                .request({
                    url: "/sqyl/admin/weeklyMenu/findDateFoodList",
                    method: "POST",
                    data: params,
                })
                .then(async (res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.tableData = []
                            this.total = 0
                            return
                        }
                        this.tableData = res.content
                        //this.total = res.content.count
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        // 关闭
        handleClose() {
            new Promise((resovle, reject) => {
                let price = 0
                this.tableData.forEach((item) => {
                    price += item.allfoodPrice
                })
                resovle(price)
            }).then((res) => {
                this.$parent.openData.title !== "查看" &&
                    this.$emit("update:allPrice", res)
                this.$emit("cancleOpen", false)
            })
        },
        // 打印
        stamp() {
            this.$print(this.$refs.print)
        },
        // 页面大小
        handleSizeChange(val) {
            this.pageSize = val
            this.getList()
        },
        // 分页大小
        handleCurrentChange(val) {
            this.pageNo = val
            this.getList()
        },
    },
}
</script>
<style lang="less" scoped></style>